import React, { useState, useEffect } from "react";

export default function CookieBanner() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookieConsent");
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const acceptAll = () => {
        localStorage.setItem("cookieConsent", "accepted");
        setShowBanner(false);
    };

    const rejectAll = () => {
        localStorage.setItem("cookieConsent", "rejected");
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl">
            <div className="max-w-7xl mx-auto px-6 py-6">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <div className="flex-1">
                        <h3 className="font-bold text-gray-900 mb-2">We value your privacy</h3>
                        <p className="text-sm text-gray-600 leading-relaxed">
                            We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
                            <a href="#" className="text-primary-600 hover:underline ml-1">Cookie Policy</a>
                        </p>
                    </div>
                    <div className="flex gap-3 shrink-0">
                        <button
                            onClick={rejectAll}
                            className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
                        >
                            Reject All
                        </button>
                        <button
                            onClick={acceptAll}
                            className="px-6 py-2.5 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
                        >
                            Accept All
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
